module.exports = __webpack_public_path__ + "static/media/senior-pastors.15589579.png";